export const BACKEND_KEY = 'Income';
export const BASE_INCOME = {
  Id: null,
  Name: null,
  IncomeType: 0,
  Earner: null,
  Amount: null,
  IncomeFrequency: 0,
  IsSpouse: false,
  BonusCommissions: null,
  AssociatedAssetId: null,
  ContinuesPostRetirement: null,
  StartAge: null,
  EndAge: null,
  Inflation: null,
  IsTaxFree: null,
  IncomeGrowth: null,
  SelfEmployed: null,
  AccountEarmark: null,
  YearlyTaxableAmount: null,
  ClientId: null,
};
